import I18n from 'i18n-js';
import React from 'react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import classNames from 'classnames';
import { useURL } from '@reverbdotcom/commons/src/url_context';

import {
  withUserContext,
  IUserContext,
} from '@reverbdotcom/commons/src/components/user_context_provider';
import { isEndedWatchesPath } from '@reverbdotcom/commons/src/url_helpers';

export const ACTIVE_CLASS = 'feed-container__tab--active';

type IProps = IUserContext;

export function FeedTabs() {
  const url = useURL();
  const watchlistClassName = classNames({ [ACTIVE_CLASS]: isEndedWatchesPath(url) });

  return (
    <nav className="feed-container__tabs">
      <ul>
        <li className="feed-container__tab">
          <CoreLink to="/my/feed" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.feed')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/my/feed/customize" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.customize')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/watched_products" activeClassName={ACTIVE_CLASS} className={watchlistClassName}>
            {I18n.t('discovery.feed.tabs.watchList')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/browsing_history" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.recentlyViewed')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/my/recommendations" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.recommended')}
          </CoreLink>
        </li>
      </ul>
    </nav>
  );
}

export default withUserContext<IProps>(FeedTabs);
